<div class="container header-container minimal-header-wrapper">
    <a (keydown.ENTER)="onClickScroll('app-breadcrumbs')" role="button"
        [attr.aria-label]="'SERVICE_CATEGORY.skipToMainAria' | translate" class="skipToMainContent">Skip to main
        content</a>
    <a routerLink="/" style="cursor: pointer" class="minimal-header">
        <img alt="Info Car" class="minimal-header__logo" src="assets/images/logo_infocar_desktop.svg" />
        <div class="minimal-header__label">
            {{ 'HEADER.logo_label' | translate }}
        </div>
    </a>
</div>
